module.exports = __webpack_public_path__ + "img/snowcup.a42567f1.jpg";